// ©2024 Austin App House. All rights reserved.
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { toggleModal } from '../../storage/actions/modalsActions';
// eslint-disable-next-line import/no-cycle
import { deleteFundingSource, makePrimaryFundingSource } from '../../storage/actions/superAdmin';
// import '../../sass/smallpages/smallpages.scss'
// import '../../sass/smallpages/smallpages-l.scss'
// import '../../sass/smallpages/smallpages-m.scss'


const PMTools = ({
  mainContainer, isReload,
}) => {
  useEffect(() => {
    // getTools();
  }, [isReload]);

  return (
    <>
    <div className='content'>

     <div className="tools_section">
        <div className="head_section">
          <h1 className="page_title">PM Tools</h1>
          <div className="block_sub">These features are in beta testing. Inquire with</div>
          <div className="block_sub"><a href="mailto:support@wurqly.com">support@wurqly.com</a>if interested in being a beta client</div>
        </div>
        <ul className="tools_list">
          <li>
            <div className="block_tools">
              <div className="page_title icon_sitemap">Site Routing</div>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="#" className="btn_link">Route your site list</a>
            </div>
          </li>
          <li>
            <div className="block_tools">
              <div className="page_title icon_curve">Project Control Center</div>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="#" className="btn_link">Track everything about your project</a>
            </div>
          </li>
          <li>
            <div className="block_tools">
              <div className="page_title icon_bulb">SW9STEIN</div>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="#" className="btn_link">Ask SW9 AI</a>
            </div>
          </li>
        </ul>
      </div>
    </div>

</>
    );
};

const mapDispatchToProps = {
  toggleModal,
  deleteFundingSource,
  makePrimaryFundingSource,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isReload: state.applicationState.isReload,
});

export default connect(mapStateToProps, mapDispatchToProps)(PMTools);
